export const CONSENT_LANGUAGES: { value: string; label: string }[] = [
  { value: 'en', label: 'English' },
  { value: 'hi', label: 'Hindi' },
  { value: 'as', label: 'Assamese' },
  { value: 'bn', label: 'Bengali' },
  { value: 'gu', label: 'Gujarati' },
  { value: 'kn', label: 'Kannada' },
  { value: 'ks', label: 'Kashmiri' },
  { value: 'kok', label: 'Konkani' },
  { value: 'ml', label: 'Malayalam' },
  { value: 'mni', label: 'Manipuri' },
  { value: 'mr', label: 'Marathi' },
  { value: 'ne', label: 'Nepali' },
  { value: 'or', label: 'Oriya' },
  { value: 'pa', label: 'Punjabi' },
  { value: 'sa', label: 'Sanskrit' },
  { value: 'sd', label: 'Sindhi' },
  { value: 'ta', label: 'Tamil' },
  { value: 'te', label: 'Telugu' },
  { value: 'ur', label: 'Urdu' },
  { value: 'brx', label: 'Bodo' },
  { value: 'sat', label: 'Santhali' },
  { value: 'mai', label: 'Maithili' },
  { value: 'doi', label: 'Dogri' },
];

export interface IConsentConfig {
  supportedLanguages: string[];
  consentRetentionDays: number;
  consentAdminEmail: string;
  consent?: Record<string, string>;
}
